import { Box, useTheme } from "@mui/material";
import Text from "../../../theme/text/Text";
import Shbutton from "../../../theme/buttons/Shbutton";
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
// import ArrowLeftAltIcon from '@mui/icons-material/ArrowLeftAltIcon';
import { tokens } from "../../../../theme";
import Inventory2Icon from '@mui/icons-material/Inventory2';
import { useCallback, useEffect, useMemo, useState } from "react";

import SidepanelHeaderActiongroup from "../../../theme/sidepanel2/SidepanelHeaderActiongroup";
import { useGridApiRef } from "@mui/x-data-grid";
import PickingLines from "./Views/PickingLines";
import Orders from "./Views/Orders";

import {useTranslation} from "react-i18next";
import { getTranslatedDateAndTime } from "../../../../utils";
import Sidepanel2 from "../../../theme/sidepanel2/Sidepanel2";
import { spPickingJobPickingListConfig } from "./spPickingJobPickingListConfig";
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import { useGetPickingJobPickingListQuery } from "../../../../newapi/pickingjob/pickingjobSlice";
import ShRowSkeleton from "../../../theme/skeleton/ShRowSkeleton";
import { getPickingJobStateData } from "../../../../utils/labelColorText";
import Subheading from "../../../theme/text/Subheading";
const SidePanelActions = (props) => {
    return (
        <SidepanelHeaderActiongroup>
            <Shbutton isCancel={true} 
                onClick={() => props.setIsExtended(false)} 
                color="primary" 
                variant="text" 
                startIcon={<ArrowRightAltIcon/>}
            >
                Close
            </Shbutton>

        </SidepanelHeaderActiongroup>
    )
}

const SpPickingJobPickingList = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);


    const { data } = props;

    const { t, ready, i18n } = useTranslation();


    const { data: pickingJobListData, isLoading,isFetching,error,isError } = useGetPickingJobPickingListQuery(props.pickingJobListId,
    {
        skip: !props.pickingJobListId
    });


    const defaultIcon = useMemo(() => ({
        theme: theme.palette.mode === "dark" ? "blue" : "primary",
        content: <FormatListNumberedIcon/>
    }), [theme.palette.mode]);

    const defaultOptions = useMemo(() => [
        { component: <ShRowSkeleton heading={t("created")} /> },
        { component: <ShRowSkeleton heading={t("appointed_to")} /> },
        { component: <ShRowSkeleton heading={t("type")} /> },
    ], [t]);
    
    const setIsExtendedCallback = useCallback(() => props.setIsExtended(false), [props.setIsExtended]);

    // Memoize the default state to avoid recalculating it on every render
    const defaultState = useMemo(() => ({
        title: "",
        subTitle: "",
        icon: defaultIcon,
        options: defaultOptions,
        actions:<SidePanelActions setIsExtended={setIsExtendedCallback} />,
        styling: {
            header : {
                padding:"0px !important",
            }
        },
    }), [defaultIcon, defaultOptions, setIsExtendedCallback]);

    const [panel, setPanel] = useState(defaultState);

    useEffect(() => {
        setPanel(defaultState);
    }, [isFetching,props.pickingJobListId,theme.palette.mode])
    
    useEffect(() => {
        if (!isLoading && !isFetching && pickingJobListData) {
            const dateTime = getTranslatedDateAndTime(pickingJobListData.pickingJob.createdAt, t);
            setPanel(prevPanel => ({ 
                ...prevPanel,
                title: `Batch ${pickingJobListData.pickingJob.id}`,
                subTitle: `${pickingJobListData.pickingJob.warehouse} - ${pickingJobListData.pickingJob.orderCount} orders`,
                icon :defaultIcon,
                options : [
                    {
                        heading: t("created"),
                        content: `${dateTime.date} ${dateTime.time}`
                    },
                    {
                        heading: t("appointed_to"),
                        content: pickingJobListData.pickingJob.userName
                    },
                    {
                        heading: t("type"),
                        content: pickingJobListData.pickingJob.type
                    },
                ],
            }));
        }
    }, [pickingJobListData, isLoading, isFetching, t,theme.palette.mode]);


    // const [panel, setPanel] = useState({
    //     title: "",
    //     subTitle: "",
    //     icon :{
    //         theme: "green",
    //         content: <Inventory2Icon/>
    //     },
    //     //Heading row for default shit
    //     options : [],
    //     actions:<SidePanelActions setIsExtended={props.setIsExtended} />   
    // });

    // useEffect(() => {
    //     if (typeof data !== "undefined" && ready) {
    //       const dateTime = getTranslatedDateAndTime(pickingJobListData.pickingJob.createdAt, t);
    //       setPanel((prevPanel) => ({
    //         ...prevPanel,
    //         title: `Batch ${pickingJobListData.pickingJob.id}`,
    //         subTitle: `${pickingJobListData.pickingJob.warehouse} - ${pickingJobListData.pickingJob.orderCount} orders`,
    //         icon :{
    //             theme: "blue",// getOrderStatusColor(props.data), 
    //             content: <Inventory2Icon/>
    //         },
    //         options : [
    //             {
    //                 heading: t("created"),
    //                 content: `${dateTime.date} ${dateTime.time}`
    //             },
    //             {
    //                 heading: t("appointed_to"),
    //                 content: pickingJobListData.pickingJob.userName
    //             },
    //             {
    //                 heading: t("type"),
    //                 content: pickingJobListData.pickingJob.type
    //             },
    //         ],
    //       }));
    //     }
    //   }, [data,ready]);

    const getBackgroundColor = useCallback((state,contrast=400) => {
        const {labelcolor,labeltext} = getPickingJobStateData(state, theme);

        if(labelcolor === "grey") {
            if(theme.palette.mode === "dark") {
                return colors["grey"][300];
            } else {
                return colors["grey"][200];
            }
        }
        return colors[labelcolor][contrast];
    });

    const getColor = useCallback((state,contrast=400) => {
        const {labelcolor,labeltext} = getPickingJobStateData(state, theme);
        if(labelcolor === "grey") {
            return colors["txt"]["primary"];
        }
        return colors[labelcolor][contrast];
    });
    
    return (
        <Sidepanel2
            isCustom
            skeleton={isLoading || isFetching}
            tabConfig={spPickingJobPickingListConfig}
            content={panel} 
            enableUrlViews={false}
            defaultTab={!isNaN(props.defaultTab) ? props.defaultTab : null}
            isExtended={props.isExtended} 
            setIsExtended={props.setIsExtended} >
                <>
                    <PickingLines config={spPickingJobPickingListConfig.pickingLines} data={pickingJobListData}/> 
                    <Orders config={spPickingJobPickingListConfig.orders} pickingJobId={props.pickingJobListId} setIsExtended={props.setIsExtended}/> 
                </>
                
                <Box
                    sx={{
                        paddingBottom:3,
                        // position:"relative",
                    }}
                >
                    <Box
                        sx={{
                            pr:3,
                            display:"flex",
                            justifyContent:"space-between",
                            alignItems:"flex-end",
                        }}
                    >
                    <Box 
                        onClick={() => {
                            // if(hasModifyPrivilege && ![general_states.SHIPPED, general_states.FULLYPICKED, general_states.PICKING_IN_PROGRESS].includes(pickingJobListData?.state)) {
                            //     updateModal.setOpen(true);
                            // }
                        }}
                        sx={{
                            background:getBackgroundColor(pickingJobListData?.pickingJob?.state,100),
                            pt:3,
                            px:3,
                            pb:2,
                            display:"flex",
                            alignItems:"center",
                            fontSize:21,
                            fontWeight:"bold",
                            fontFamily:"Roboto, sans-serif",
                            color: getColor(pickingJobListData?.pickingJob?.state,400),
                            borderBottomRightRadius:24,
                            "@media screen and (max-width: 47.9375em)" : {
                                position:"absolute",
                                top:0,
                            },
                            "@media screen and (max-width: 566px)" : {
                                display:"none"
                            },
                            position:"relative",
                            cursor:"pointer",
                            // "&::before": {
                            //     content: '""',
                            //     position: "absolute",
                            //     left: 0,
                            //     top: 0,
                            //     height: '100%',
                            //     width: '100%',
                            //     borderBottomRightRadius:24,
                            //     background: "transparent",
                            //     zIndex: 1,
                            //     pointerEvents: "none",
                            //     transition: hasModifyPrivilege && ![general_states.SHIPPED, general_states.FULLYPICKED, general_states.PICKING_IN_PROGRESS, general_states.CANCELLED].includes(pickingJobListData?.state) ? 
                            //         "background 200ms cubic-bezier(0.4, 0, 0.2, 1), border 200ms cubic-bezier(0.4, 0, 0.2, 1)" : "none",
                            // },
                            // "&:hover&::before": {
                            //     background: hasModifyPrivilege && ![general_states.SHIPPED, general_states.FULLYPICKED, general_states.PICKING_IN_PROGRESS].includes(pickingJobListData?.state) ?"rgba(0,0,0, 0.2)" : "transparent"
                            // }
                        }}
                    >
                        {t(getPickingJobStateData(pickingJobListData?.pickingJob?.state, theme).labeltext)}
                        {/* {pickingJobListData && hasModifyPrivilege && ![general_states.SHIPPED, general_states.FULLYPICKED, general_states.PICKING_IN_PROGRESS, general_states.CANCELLED].includes(pickingJobListData?.state) &&
                            <EditIcon sx={{marginLeft:1.5}} />
                        } */}
                    </Box>
                    
                    </Box>

                    <Box
                        sx={{
                            px:3,
                            pt:4,
                            display:"flex",
                            justifyContent:"space-between",
                            alignItems:"center",
                            "@media screen and (max-width: 47.9375em)" : {
                                flexDirection:"column"
                            }
                        }}
                    >
                        <Box
                            sx={{
                                "@media screen and (max-width: 47.9375em)" : {
                                    display:"flex",
                                    alignItems:"center",
                                    flexDirection:"column",
                                    mb:3,
                                }
                            }}
                        >
                            <Box
                                sx={{

                                    display:"flex",
                                    alignItems:"center",
                                    gap:2,
                                }}
                            >
                                <Box
                                    sx={{
                                        display:"flex",
                                        gap:1,
                                    }}
                                >
                                    <Subheading> {t("pickingjob")} {pickingJobListData?.pickingJob.barcode}</Subheading>
                                </Box>
                            </Box>
                            <Box
                                sx={{
                                    display:"flex",
                                    flexDirection:"column",
                                }}
                            >
                                <Text italic>{pickingJobListData?.pickingJob.orderCount} {t("orders")}</Text>
                            <   Text light>{pickingJobListData?.pickingJob.warehouse ?? t("unknown")}</Text>
                            </Box>

                        </Box>
{/* <Subheading */}
                        <Box
                            sx={{
                                "@media screen and (max-width: 47.9375em)" : {
                                    display:"flex",
                                    // gap:2,
                                    // flexDirection:"column"
                                },
                                "@media screen and (max-width: 566px)" : {
                                    width:1,
                                    flexDirection:"column"
                                }
                            }}
                        >

                            <Box
                                onClick={() => {
                                    // if(hasModifyPrivilege && ![general_states.SHIPPED, general_states.FULLYPICKED, general_states.PICKING_IN_PROGRESS].includes(pickingJobListData?.state)) {
                                    //     updateModal.setOpen(true);
                                    // }
                                }}
                                sx={{
                                    // height:40,
                                    lineHeight:"40px",
                                    background:getBackgroundColor(pickingJobListData?.pickingJob.state,100),
                                    px:3,
                                    fontSize:14,
                                    fontWeight:"bold",
                                    fontFamily:"Roboto, sans-serif",
                                    color: getColor(pickingJobListData?.pickingJob.state),
                                    borderRadius:20,
                                    display:"none",
                                    alignItems:"center",
                                    flex:1,
                                    "@media screen and (max-width: 47.9375em)" : {
                                        display:"flex",
                                        borderBottomRightRadius:0,
                                        borderBottomLeftRadius:0,
                                        borderTopLeftRadius:"24px",
                                        borderTopRightRadius:"24px",
                                    },
                                    "@media screen and (max-width: 566px)" : {
                                        justifyContent:"center"
                                    }
                                }}
                            >
                                {t(getPickingJobStateData(pickingJobListData?.pickingJob?.state, theme).labeltext)}
                            </Box>
                            <Box
                                sx={{
                                    display:"flex",
                                    alignItems:"center",
                                    gap:4,
                                    borderRadius:7,
                                    height:56,
                                    px:4,
                                    background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                                    "@media screen and (max-width: 47.9375em)" : {
                                        borderTopLeftRadius:0,
                                        borderTopRightRadius:0,
                                        borderBottomLeftRadius:"24px",
                                        borderBottomRightRadius:"24px",
                                        // width:400,
                                    },
                                    "@media screen and (max-width: 566px)" : {
                                        flexDirection:"column",
                                        gap:1.5,
                                        height:"unset",
                                        px:3,
                                        py:2,
                                    }
                                }}
                            >
                                <Box
                                    sx={{
                                        display:"flex",
                                        flexDirection:"column",
                                        "@media screen and (max-width: 566px)" : {
                                            flexDirection:"row",
                                            width:1,
                                            justifyContent:"space-between",
                                        }
                                    }}
                                >
                                    
                                    <Text sx={{flexShrink:0}} light noBreak>{t("appointed_to")}</Text>
                                    <Text>{pickingJobListData?.pickingJob.userName}</Text>
                                </Box>
                                <Box
                                    sx={{
                                        display:"flex",
                                        flexDirection:"column",
                                        "@media screen and (max-width: 566px)" : {
                                            flexDirection:"row",
                                            width:1,
                                            justifyContent:"space-between",
                                        }
                                    }}
                                >
                                    <Text noBreak light>{t("total_locations")}</Text>
                                    <Text>{pickingJobListData?.pickingJob.total_locations}</Text>
                                </Box>
                                <Box
                                    sx={{
                                        display:"flex",
                                        flexDirection:"column",
                                        "@media screen and (max-width: 566px)" : {
                                            flexDirection:"row",
                                            width:1,
                                            justifyContent:"space-between",
                                        }
                                    }}
                                >
                                    <Text light>{t("total_products")}</Text>
                                    <Text>{pickingJobListData?.pickingJob.total_products}</Text>
                                </Box>
                            </Box>
                            
                        </Box>

                    </Box>
                </Box>
        </Sidepanel2>
    );
};

export default SpPickingJobPickingList;